import { createContext, useContext, type ReactNode } from 'react'

/**
 * Where overlays sit on document.body: drawers, then dialogs and confirms
 * above them, then toasts above everything.
 */
export const LAYERS = { drawer: 50, dialog: 60, toast: 70 } as const

const OverlayLayerContext = createContext(0)

/**
 * The z-index for an overlay: its own layer, or one above the overlay it was
 * opened from, whichever is higher. Context crosses portals, so a drawer opened
 * inside a dialog sits above that dialog, and a confirm opened from that drawer
 * sits above both. Wrap the overlay's content in <OverlayLayer> with the result.
 */
export function useOverlayLayer(layer: number): number {
  return Math.max(layer, useContext(OverlayLayerContext) + 1)
}

/** Tells overlays opened inside this one which z-index to stack above. */
export function OverlayLayer({ zIndex, children }: { zIndex: number; children: ReactNode }) {
  return <OverlayLayerContext.Provider value={zIndex}>{children}</OverlayLayerContext.Provider>
}
